<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <vx-card-custom :cardBorder="true" title="Standard pricing" class="mb-4">

          <div class="vx-row mb-3">
            <div class="vx-col md:s-full md:w-1/2 w-full">
              <ValidationProvider vid="unit_id" name="unit_id" rules="required" v-slot="{ errors }">
                <small class="label">Unit Type</small>
                <v-select  :filter-by="myUnitFilter"  :clearable="false" name="unit_id" placeholder="" label="name" v-model="form.unit_id" :reduce="option => option.id" :options="unitList" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.unit}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:s-full md:w-1/2 w-full">
              <ValidationProvider vid="currency_id" name="currency_id" rules="required" v-slot="{ errors }">
                <small class="label">Currency</small>
                <v-select  :filter-by="myCurrencyFilter"  :clearable="false" name="currency_id" placeholder="" label="name" v-model="form.currency_id" :reduce="option => option.id" :options="currencyList" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="min_order_quantity" name="min_order_quantity" rules="min_than:@max_order_quantity|required" v-slot="{ errors }">
                <small class="label">Min Order Quantity</small>
                <vs-input  type="number" v-model="form.min_order_quantity" name="min_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="max_order_quantity" name="max_order_quantity" rules="max_than:@min_order_quantity|required" v-slot="{ errors }">
                <small class="label">Max Order Quantity</small>
                <vs-input  type="number" v-model="form.max_order_quantity" name="max_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 md:mb-0">
              <ValidationProvider vid="is_volume_price_tiers" name="is_volume_price_tiers" rules="" v-slot="{ errors }">
                <small class="label">are there price volume tiers?</small>
                <vs-switch disabled v-model="form.is_volume_price_tiers" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div v-if="form.is_volume_price_tiers" v-for="(prices_tier, index) in form.prices_tier" :key="index">
            <div class="vx-row mb-3" >
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'min_order_quantity'" :name="index+'min_order_quantity'" :rules="''" v-slot="{ errors }">
                  <small class="label">Min order quantity</small>
                  <vs-input disabled v-model="prices_tier.min_order_quantity" type="number" name="min_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'max_order_quantity'" :name="index+'max_order_quantity'" :rules="''" v-slot="{ errors }">
                  <small class="label">Max order quantity</small>
                  <vs-input disabled v-model="prices_tier.max_order_quantity" type="number" name="max_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'price_per_unit'" :name="index+'price_per_unit'" rules="" v-slot="{ errors }">
                  <small class="label">Price per unit</small>
                  <vs-input disabled v-model="prices_tier.price_per_unit" type="text" name="price_per_unit" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'payment_terms'" :name="index+'payment_terms'" rules="" v-slot="{ errors }">
                  <small class="label">Payment terms (Days)</small>
                  <vs-input disabled v-model="prices_tier.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'delivery_terms'" :name="index+'delivery_terms'" rules="" v-slot="{ errors }">
                  <small class="label">Delivery terms (Days)</small>
                  <vs-input disabled v-model="prices_tier.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <small class="label">&nbsp;</small>
  <!--              <vs-button :disabled="form.prices_tier.length < 3" class="" @click="deleteProceTier(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>-->
              </div>
            </div>
          </div>
  <!--        <vs-button v-if="form.is_volume_price_tiers" @click="addPriceTier" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add prices tier</vs-button>-->

          <div class="vx-row mb-3" v-if="!form.is_volume_price_tiers">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price_per_unit" name="price_per_unit" rules="" v-slot="{ errors }">
                <small class="label">Price per unit</small>
                <vs-input disabled v-model="form.prices.price_per_unit" type="price_per_unit" name="price_per_unit" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="payment_terms" name="payment_terms" rules="" v-slot="{ errors }">
                <small class="label">Payment term (Days)</small>
                <vs-input disabled v-model="form.prices.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="delivery_terms" name="delivery_terms" rules="" v-slot="{ errors }">
                <small class="label">Delivery term (Days)</small>
                <vs-input disabled v-model="form.prices.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

        </vx-card-custom>


        <vx-card-custom :cardBorder="true" title="Spot pricing" class="mb-4">

          <div class="vx-row mb-3 mt-8">
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider vid="is_contracted" name="is_contracted" rules="" v-slot="{ errors }">
                <small class="label">Spot price offer for limited time</small>
                <vs-switch  v-model="form.is_contracted" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider v-if="form.is_contracted" vid="contract_start_date" name="contract_start_date" rules="required" v-slot="{ errors }">
                <small class="label">Contract Start Date</small>
                <flat-pickr style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="form.contract_start_date"
                  placeholder="Choose Date"
                />
                <flat-pickr placeholder="Choose Date" class="w-full" v-model="form.contract_start_date" :config="{ dateFormat: 'd/m/Y'}" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider v-if="form.is_contracted" vid="contract_end_date" name="contract_end_date" rules="required" v-slot="{ errors }">
                <small class="label">Contract End Date</small>
                <flat-pickr style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="form.contract_end_date"
                  placeholder="Choose Date"
                />
                <flat-pickr placeholder="Choose Date" class="w-full" v-model="form.contract_end_date" :config="{ dateFormat: 'd/m/Y', minDate: form.contract_start_date}" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3 mt-8" v-if="form.is_contracted">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.is_contracted" vid="contract_start_date" name="contract_start_date" rules="required" v-slot="{ errors }">
                <small class="label">Reason for offer</small>
                <v-select  :clearable="false" name="reason_for_offer" placeholder="" label="name" v-model="form.reason_for_offer" :reduce="option => option.value"
                           :options="[{name: 'Short Shelf Life', value: 'Short_Shelf_Life'}, {name: 'Over Stock', value: 'Over_Stock'}, {name: 'Sale', value: 'Sale'}]"
                           :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.reason_for_offer === 'Short_Shelf_Life'" vid="contract_end_date" name="contract_end_date" rules="required" v-slot="{ errors }">
                <small class="label">Short shelf life expiry</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="form.short_shelf_life_expiry"
                            placeholder="Choose Date"
                />
                <flat-pickr placeholder="Choose Date" class="w-full" v-model="form.short_shelf_life_expiry" :config="{ dateFormat: 'd/m/Y'}" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.is_contracted">
            <div class="vx-col md:w-1/3 md:mb-0">
              <ValidationProvider vid="is_contract_volume_price_tiers" name="is_contract_volume_price_tiers" rules="" v-slot="{ errors }">
                <small class="label">are there price volume tiers?</small>
                <vs-switch  v-model="form.is_contract_volume_price_tiers" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div v-if="form.is_contract_volume_price_tiers && form.is_contracted" v-for="(volume_price_tiers, index) in form.contract_prices_tier" :key="index">
            <div class="vx-row mb-3" >
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'volume_price_tiers_min_order_quantity'" :name="index+'volume_price_tiers_min_order_quantity'" :rules="validate_contract_prices_tier(index)" v-slot="{ errors }">
                  <small class="label">Min order quantity</small>
                  <vs-input  v-model="volume_price_tiers.min_order_quantity" type="number" name="min_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'volume_price_tiers_max_order_quantity'" :name="index+'volume_price_tiers_max_order_quantity'" :rules="validate_max_contract_price_tier(index)" v-slot="{ errors }">
                  <small class="label">Max order quantity</small>
                  <vs-input  v-model="volume_price_tiers.max_order_quantity" type="number" name="max_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'volume_price_tiers_rice_per_unit'" :name="index+'volume_price_tiers_price_per_unit'" rules="required" v-slot="{ errors }">
                  <small class="label">Price per unit</small>
                  <vs-input  v-model="volume_price_tiers.price_per_unit" type="text" name="price_per_unit" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'volume_price_tiers_payment_terms'" :name="index+'volume_price_tiers_payment_terms'" rules="required" v-slot="{ errors }">
                  <small class="label">Payment terms (Days)</small>
                  <vs-input  v-model="volume_price_tiers.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'volume_price_tiers_delivery_terms'" :name="index+'volume_price_tiers_delivery_terms'" rules="required" v-slot="{ errors }">
                  <small class="label">Delivery terms (Days)</small>
                  <vs-input  v-model="volume_price_tiers.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <small class="label">&nbsp;</small>
                <vs-button :disabled="form.contract_prices_tier.length < 3" class="" @click="deleteVolumnPriceTier(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
              </div>
            </div>
          </div>
          <vs-button v-if="form.is_contract_volume_price_tiers && form.is_contracted" @click="addVolumnPriceTier" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add contract prices tier</vs-button>


          <div class="vx-row mb-3 mt-3" v-if="!form.is_contract_volume_price_tiers && form.is_contracted">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="contract_prices_price_per_unit" name="contract_prices_price_per_unit" rules="required" v-slot="{ errors }">
                <small class="label">Price per unit</small>
                <vs-input  type="text" v-model="form.contract_prices.price_per_unit"  name="min_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="contract_prices_payment_terms" name="contract_prices_payment_terms" rules="required" v-slot="{ errors }">
                <small class="label">Payment term (Days)</small>
                <vs-input  v-model="form.contract_prices.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="contract_prices_delivery_terms" name="contract_prices_delivery_terms" rules="required" v-slot="{ errors }">
                <small class="label">Delivery term (Days)</small>
                <vs-input  v-model="form.contract_prices.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
        </vx-card-custom>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_commercial_complete"  button="submit" class="ml-auto mt-2" >Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" >Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>

    <div class="vx-row mt-2 mb-4" v-if="status.is_raw_material_commercial_complete">
      <div class="vx-col">
        <h5>Price change requests</h5>
        <vs-button @click="onClickCreatePriceChangeRequest" size="small" class="mt-2" >
          Submit price change</vs-button>
      </div>
    </div>

    <div class="vx-row mt-8" v-if="status.is_raw_material_commercial_complete">
      <div class="vx-col w-full">
        <vs-table :data="price_change_requests">

          <template slot="thead">
            <vs-th>PRODUCT NAME</vs-th>
            <vs-th>REQUESTED BY</vs-th>
            <vs-th>PROPOSED DATE</vs-th>
            <vs-th>STATUS</vs-th>
            <vs-th>ACTION</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].product_name">
                {{ data[indextr].product_name}}
              </vs-td>

              <vs-td :data="data[indextr].requested_by_full_name">
                {{ data[indextr].requested_by_full_name }}
              </vs-td>

              <vs-td :data="data[indextr].proposed_date">
                {{ data[indextr].proposed_date }}
              </vs-td>

              <vs-td :data="data[indextr].status">
                {{ data[indextr].status }}
              </vs-td>

              <vs-td>
                <div class="vx-row">
                  <vx-tooltip text="View price change request" position="left">
                    <vs-button @click.stop="onClickPriceChangeRequestView(data[indextr].id)"
                               size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>

            </vs-tr>
          </template>

        </vs-table>
      </div>
    </div>

    <create-raw-material-price-request-pop-up v-on:refreshData="refreshData" ref="createRawMaterialPriceRequestPopUp"/>
    <view-raw-material-price-request-pop-up ref="viewRawMaterialPriceRequestPopUp"/>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import CreateRawMaterialPriceRequestPopUp from "@/components/popups/raw-materials/CreateRawMaterialPriceRequestPopUp";
  import ViewRawMaterialPriceRequestPopUp from "@/components/popups/raw-materials/ViewRawMaterialPriceRequestPopUp";

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        unitList: [],
        currencyList: [],
        form: {
          prices: {
            price_per_unit: null,
            payment_terms: null,
            delivery_terms: null
          },
          contract_prices:{
            price_per_unit: null,
            payment_terms: null,
            delivery_terms: null
          },
          prices_tier: [
            {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''},
            {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
          ],
          contract_prices_tier: [
            {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''},
            {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
          ],
          is_volume_price_tiers: false,
          is_contracted: false,
          is_contract_volume_price_tiers: false,
        },
        id: null,
        status: {},
        legislative_status_item_display_names: [
          'Natural Flavouring Substance', 'Flavouring Substance', 'Flavouring Preparation', 'Smoke Flavouring',
          'Other (please specify)'
        ],
        price_change_requests: [],
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
      flatPickr,
      CreateRawMaterialPriceRequestPopUp,
      ViewRawMaterialPriceRequestPopUp,
    },
    methods: {
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
      },
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_commercial_complete ? this.onClickUpdate() : this.onClickCreate()
      },
      onClickCreatePriceChangeRequest() {
        this.$refs.createRawMaterialPriceRequestPopUp.openPopup(this.id)
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_volume_price_tiers) {
            this.form.prices_tier = []
          }
          if (!this.form.is_contract_volume_price_tiers) {
            this.form.contract_prices_tier = []
          }
          if (!this.form.is_contracted) {
            this.form.contract_prices = {
              price_per_unit: null,
              payment_terms: null,
              delivery_terms: null
            }
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialCommercialDetails(this.id, this.form))
          this.showSuccessMessage('Raw Material Commercial Details Details Updated!')
          location.reload();
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (!this.form.is_volume_price_tiers) {
            this.form.prices_tier = []
          }
          if (!this.form.is_contract_volume_price_tiers) {
            this.form.contract_prices_tier = []
          }
          if (!this.form.is_contracted) {
            this.form.contract_prices = {
              price_per_unit: null,
              payment_terms: null,
              delivery_terms: null
            }
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialCommercialDetails(this.form))
          this.showSuccessMessage('Raw Material Commercial Details  Details Created!')
          location.reload();
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialCommercialDetails(this.id)).data
        this.form = data
        if (!this.form.prices_tier || this.form.prices_tier.length === 0) {
          this.addPriceTier()
          this.addPriceTier()
        }
        if (!this.form.contract_prices_tier || this.form.contract_prices_tier.length === 0) {
          this.addVolumnPriceTier()
          this.addVolumnPriceTier()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async fetchRawMaterialPriceChangeRequests() {
        try {
          const { data } = ( await SupplierRawMaterialRepository.getListOfPriceChange(this.id)).data
          this.price_change_requests = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async loadCurrencyAndUnit() {
        this.currencyList = (await SupplierRawMaterialRepository.getCurrencyList()).data.data
        this.unitList = (await SupplierRawMaterialRepository.getUnitList()).data.data
      },
      addPriceTier() {
        this.form.prices_tier.push(
          {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
        )
      },
      addVolumnPriceTier() {
        this.form.contract_prices_tier.push(
          {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
        )
      },
      deleteProceTier(index) {
        this.form.prices_tier.splice(index, 1)
      },
      deleteVolumnPriceTier(index) {
        this.form.contract_prices_tier.splice(index, 1)
      },
      myUnitFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.unit.toLowerCase().indexOf(temp) > -1
      },
      myCurrencyFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.code.toLowerCase().indexOf(temp) > -1
      },
      validate_contract_prices_tier(index) {
        let previousIndex = index - 1
        return `min_than:@${index}volume_price_tiers_max_order_quantity|cross_over_max:@${previousIndex}volume_price_tiers_max_order_quantity|required`
      },
      validate_max_contract_price_tier(index) {
        return `max_than:@${index}volume_price_tiers_min_order_quantity|required`
      },
      validate_prices_tier(index) {
        let previousIndex = index - 1
        return `min_than:@${index}max_order_quantity|cross_over_max:@${previousIndex}max_order_quantity|required`
      },
      validate_max_price_tier(index) {
        return `max_than:@${index}min_order_quantity|required`
      },
      async refreshData() {
        await this.fetchRawMaterialPriceChangeRequests()
        if (this.status.is_raw_material_commercial_complete) {
          await this.loadData()
        }
      },
      onClickPriceChangeRequestView(id) {
        this.$refs.viewRawMaterialPriceRequestPopUp.openPopup(id)
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadCurrencyAndUnit()
      await this.loadStatus()
      await this.fetchRawMaterialPriceChangeRequests()
      if (this.status.is_raw_material_commercial_complete) {
        await this.loadData()
      }
      if(this.$route.query.price_request) {
        await this.$refs.viewRawMaterialPriceRequestPopUp.openPopup(this.$route.query.price_request)
      }
    }
  }
</script>

<style scoped>

</style>
